import React from 'react';
import { BookOpenIcon, TrendingUpIcon, DollarSignIcon, LightbulbIcon, ArrowRightIcon } from 'lucide-react';
const FinancialTipsEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-1131">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1132">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-8 py-12 text-center" data-id="element-1133">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1134">
            <BookOpenIcon size={32} className="text-emerald-600" data-id="element-1135" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-1136">
            Consejos Financieros
          </h1>
          <p className="text-emerald-100 text-lg" data-id="element-1137">
            Newsletter Mensual - Enero 2024
          </p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-1138">
          <div className="mb-8" data-id="element-1139">
            <p className="text-gray-700 text-lg mb-4" data-id="element-1140">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-1141">
              Este mes te compartimos estrategias prácticas para optimizar las
              finanzas de <strong data-id="element-1142">PYME Solutions</strong> y mantener un
              crecimiento saludable.
            </p>
          </div>
          {/* Featured Tip */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 mb-8 border border-emerald-200" data-id="element-1143">
            <div className="flex items-start space-x-4" data-id="element-1144">
              <div className="w-12 h-12 rounded-full bg-emerald-600 flex items-center justify-center flex-shrink-0" data-id="element-1145">
                <LightbulbIcon size={24} className="text-white" data-id="element-1146" />
              </div>
              <div data-id="element-1147">
                <h2 className="text-xl font-semibold text-emerald-900 mb-2" data-id="element-1148">
                  Consejo del mes
                </h2>
                <p className="text-emerald-800 mb-4" data-id="element-1149">
                  <strong data-id="element-1150">Optimiza tu capital de trabajo:</strong> Mantén un
                  equilibrio saludable entre activos y pasivos circulantes.
                  Idealmente, tu razón circulante debe estar entre 1.5 y 2.0.
                  Actualmente PYME Solutions tiene una razón de 2.4, lo cual es
                  excelente.
                </p>
                <a href="#" className="text-emerald-700 hover:text-emerald-800 font-medium text-sm flex items-center space-x-1" data-id="element-1151">
                  <span data-id="element-1152">Leer artículo completo</span>
                  <ArrowRightIcon size={16} data-id="element-1153" />
                </a>
              </div>
            </div>
          </div>
          {/* Tips Section */}
          <div className="mb-8" data-id="element-1154">
            <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-1155">
              📊 Estrategias para tu negocio
            </h2>
            <div className="space-y-6" data-id="element-1156">
              {/* Tip 1 */}
              <div className="border-l-4 border-blue-500 bg-blue-50 p-5 rounded-r-lg" data-id="element-1157">
                <div className="flex items-start space-x-3" data-id="element-1158">
                  <TrendingUpIcon size={24} className="text-blue-600 flex-shrink-0 mt-1" data-id="element-1159" />
                  <div data-id="element-1160">
                    <h3 className="font-semibold text-blue-900 mb-2" data-id="element-1161">
                      Mejora tu flujo de caja
                    </h3>
                    <p className="text-blue-800 text-sm mb-3" data-id="element-1162">
                      El flujo de caja es el alma de tu negocio. Aquí algunas
                      estrategias:
                    </p>
                    <ul className="space-y-2 text-sm text-blue-800" data-id="element-1163">
                      <li className="flex items-start space-x-2" data-id="element-1164">
                        <span className="text-blue-600 mt-1" data-id="element-1165">•</span>
                        <span data-id="element-1166">
                          Negocia mejores términos de pago con proveedores
                          (30-45 días)
                        </span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1167">
                        <span className="text-blue-600 mt-1" data-id="element-1168">•</span>
                        <span data-id="element-1169">
                          Ofrece descuentos por pronto pago a tus clientes
                          (2-5%)
                        </span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1170">
                        <span className="text-blue-600 mt-1" data-id="element-1171">•</span>
                        <span data-id="element-1172">
                          Mantén un colchón de efectivo equivalente a 3 meses de
                          gastos
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Tip 2 */}
              <div className="border-l-4 border-purple-500 bg-purple-50 p-5 rounded-r-lg" data-id="element-1173">
                <div className="flex items-start space-x-3" data-id="element-1174">
                  <DollarSignIcon size={24} className="text-purple-600 flex-shrink-0 mt-1" data-id="element-1175" />
                  <div data-id="element-1176">
                    <h3 className="font-semibold text-purple-900 mb-2" data-id="element-1177">
                      Reduce costos sin sacrificar calidad
                    </h3>
                    <p className="text-purple-800 text-sm mb-3" data-id="element-1178">
                      Identifica áreas donde puedes optimizar gastos:
                    </p>
                    <ul className="space-y-2 text-sm text-purple-800" data-id="element-1179">
                      <li className="flex items-start space-x-2" data-id="element-1180">
                        <span className="text-purple-600 mt-1" data-id="element-1181">•</span>
                        <span data-id="element-1182">
                          Revisa y renegocia contratos de servicios anuales
                        </span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1183">
                        <span className="text-purple-600 mt-1" data-id="element-1184">•</span>
                        <span data-id="element-1185">
                          Implementa tecnología para automatizar procesos
                          repetitivos
                        </span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1186">
                        <span className="text-purple-600 mt-1" data-id="element-1187">•</span>
                        <span data-id="element-1188">
                          Analiza el ROI de cada gasto de marketing y ajusta tu
                          presupuesto
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Tip 3 */}
              <div className="border-l-4 border-green-500 bg-green-50 p-5 rounded-r-lg" data-id="element-1189">
                <div className="flex items-start space-x-3" data-id="element-1190">
                  <TrendingUpIcon size={24} className="text-green-600 flex-shrink-0 mt-1" data-id="element-1191" />
                  <div data-id="element-1192">
                    <h3 className="font-semibold text-green-900 mb-2" data-id="element-1193">
                      Diversifica tus fuentes de ingreso
                    </h3>
                    <p className="text-green-800 text-sm mb-3" data-id="element-1194">
                      No dependas de un solo cliente o producto:
                    </p>
                    <ul className="space-y-2 text-sm text-green-800" data-id="element-1195">
                      <li className="flex items-start space-x-2" data-id="element-1196">
                        <span className="text-green-600 mt-1" data-id="element-1197">•</span>
                        <span data-id="element-1198">
                          Desarrolla nuevos productos o servicios
                          complementarios
                        </span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1199">
                        <span className="text-green-600 mt-1" data-id="element-1200">•</span>
                        <span data-id="element-1201">Explora nuevos segmentos de mercado</span>
                      </li>
                      <li className="flex items-start space-x-2" data-id="element-1202">
                        <span className="text-green-600 mt-1" data-id="element-1203">•</span>
                        <span data-id="element-1204">
                          Considera modelos de ingreso recurrente
                          (suscripciones)
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Industry News */}
          <div className="bg-gray-50 rounded-lg p-6 mb-8" data-id="element-1205">
            <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1206">
              📰 Noticias del sector
            </h2>
            <div className="space-y-4" data-id="element-1207">
              <div className="pb-4 border-b border-gray-200 last:border-b-0 last:pb-0" data-id="element-1208">
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-1209">
                  Nuevas reformas fiscales 2024
                </h3>
                <p className="text-sm text-gray-600 mb-2" data-id="element-1210">
                  El SAT anuncia cambios en la facturación electrónica a partir
                  de marzo. Asegúrate de actualizar tu sistema.
                </p>
                <a href="#" className="text-sm text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-1211">
                  Leer más →
                </a>
              </div>
              <div className="pb-4 border-b border-gray-200 last:border-b-0 last:pb-0" data-id="element-1212">
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-1213">
                  Tendencias de financiamiento para PYMEs
                </h3>
                <p className="text-sm text-gray-600 mb-2" data-id="element-1214">
                  Nuevas opciones de crédito con tasas preferenciales para
                  empresas tecnológicas en México.
                </p>
                <a href="#" className="text-sm text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-1215">
                  Leer más →
                </a>
              </div>
              <div className="pb-4 border-b border-gray-200 last:border-b-0 last:pb-0" data-id="element-1216">
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-1217">
                  Cómo prepararte para una auditoría
                </h3>
                <p className="text-sm text-gray-600 mb-2" data-id="element-1218">
                  Checklist completo de documentos y mejores prácticas para
                  facilitar el proceso.
                </p>
                <a href="#" className="text-sm text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-1219">
                  Leer más →
                </a>
              </div>
            </div>
          </div>
          {/* Resources */}
          <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg p-6 mb-8 border border-emerald-200" data-id="element-1220">
            <h2 className="text-lg font-semibold text-emerald-900 mb-4" data-id="element-1221">
              📚 Recursos recomendados
            </h2>
            <ul className="space-y-3" data-id="element-1222">
              <li data-id="element-1223">
                <a href="#" className="text-emerald-700 hover:text-emerald-800 font-medium flex items-center space-x-2" data-id="element-1224">
                  <ArrowRightIcon size={16} data-id="element-1225" />
                  <span data-id="element-1226">
                    Webinar: Estrategias de crecimiento para PYMEs en 2024
                  </span>
                </a>
              </li>
              <li data-id="element-1227">
                <a href="#" className="text-emerald-700 hover:text-emerald-800 font-medium flex items-center space-x-2" data-id="element-1228">
                  <ArrowRightIcon size={16} data-id="element-1229" />
                  <span data-id="element-1230">Guía: Cómo interpretar tus estados financieros</span>
                </a>
              </li>
              <li data-id="element-1231">
                <a href="#" className="text-emerald-700 hover:text-emerald-800 font-medium flex items-center space-x-2" data-id="element-1232">
                  <ArrowRightIcon size={16} data-id="element-1233" />
                  <span data-id="element-1234">
                    Plantilla: Presupuesto anual para empresas de servicios
                  </span>
                </a>
              </li>
            </ul>
          </div>
          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-1235">
            <a href="/" className="inline-block bg-emerald-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-emerald-700 transition-colors" data-id="element-1236">
              Ver más recursos
            </a>
          </div>
          {/* Footer */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1237">
            <p className="text-gray-600 text-sm mb-2" data-id="element-1238">
              ¿Tienes alguna pregunta o tema que te gustaría que cubramos?
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1239">
              Escríbenos a{' '}
              <a href="mailto:contenido@financepro.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-1240">
                contenido@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1241">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1242">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1243">
            Recibiste este correo porque estás suscrito a nuestro newsletter.
          </p>
        </div>
      </div>
    </div>;
};
export default FinancialTipsEmail;